import { Header, Text } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { canonicalizeString } from '../../../lib/utils';
import { COUNTRY_CODES } from '../../constants';
import CAN_PROVINCES from '../../constants/caProvinces';
import USA_STATES from '../../constants/usStates';
import styles from './SearchStateCloud.module.css';

const cx = classnames.bind(styles);

function getRegionsByCountryCode(countryCode) {
  switch (countryCode) {
    case COUNTRY_CODES.CANADA:
      return CAN_PROVINCES;
    default:
      return USA_STATES;
  }
}

export default function SearchStateCloud({ country }) {
  const { t } = useTranslation(['price', 'address']);
  const isCanada = country === COUNTRY_CODES.CANADA;
  const regions = getRegionsByCountryCode(country);
  const headerText = isCanada
    ? t('searchByProvinceHeader', { ns: 'price' })
    : t('searchByStateHeader', { ns: 'price' });
  const subHeaderText = isCanada
    ? t('searchByProvinceSubHeader', { ns: 'price' })
    : t('searchByStateSubHeader', { ns: 'price' });

  return (
    <Fragment>
      <Header as="h2" className={cx('header')}>
        {headerText}
      </Header>
      <Text as="p" centered>
        {subHeaderText}
      </Text>
      <div className={cx('contents', { outsideUS: country !== COUNTRY_CODES.USA })}>
        {regions.map(region => (
          <div key={`region-${region.abbr}`} className={cx('regionContainer')}>
            <Link
              to={canonicalizeString(`/gasprices/${region.name}`)}
              className={cx('region')}
              aria-label={t(`regions.${country}.${region.abbr}`, { ns: 'address' })}
            >
              {region.abbr}
            </Link>
          </div>
        ))}
      </div>
    </Fragment>
  );
}

SearchStateCloud.propTypes = {
  country: PropTypes.oneOf(Object.values(COUNTRY_CODES)),
};

SearchStateCloud.defaultProps = {
  country: COUNTRY_CODES.USA,
};
